module.exports = __webpack_public_path__ + "static/media/PCR.7cce3b6e.md";